import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ListComponent } from './fi-checklist2-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiChecklist2ListProgressCellComponent } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-progress-cell/fi-checklist2-list-progress-cell.component';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChecklist2ListExtendedSearchComponent } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list-extended-search/fi-checklist2-list-extended-search.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatCardModule,
        MatSortModule,
        MatTableModule,
        MatMenuModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiWrapperTableModule,
        FiItemsListModule,
        FiWhenScrolledModule,
        FiLineClampModule,
        FiFormatDateModule,
        FiLoadingModule,
        FiLocalSearch2Module,
        MatProgressBarModule,
        FiChecklist2ListColumnDefsModule,
    ],
    declarations: [FiChecklist2ListComponent, FiChecklist2ListExtendedSearchComponent],
    exports: [],
})
export class FiChecklist2ListModule {}
